import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { REMEMBER_REHYDRATED } from 'redux-remember'
import { initialAppState } from 'store/app/initial'
import { switchLanguage } from './thunks'
import { AppStore, SetMoveFlowStatePayload, UrlSearchParamsKeys } from 'store/app/types'
import { Language, MoveFlow } from '@boltenergy-be/shared'

export const appSlice = createSlice({
  name: 'app',
  initialState: initialAppState,
  reducers: {
    activateBetaMode: (state) => {
      state.betaMode = true
    },
    saveRedirect: (state, { payload }: PayloadAction<string>) => {
      state.redirect = payload
      state.error = null
    },
    deleteRedirect: (state) => {
      state.redirect = null
      state.error = null
    },
    toggleShowAllAddresses: (state) => {
      state.showAllAddresses = !state.showAllAddresses
    },
    setShowAllAddresses: (state, { payload }: PayloadAction<boolean>) => {
      state.showAllAddresses = payload
    },
    saveUrlSearchParam: (state, { payload }: PayloadAction<{ key: UrlSearchParamsKeys; value: string }>) => {
      state.urlSearchParams[payload.key] = payload.value
    },
    setMoveFlow: (state, { payload }: PayloadAction<MoveFlow>) => {
      state.move.flow = payload
    },
    setMoveFlowState: (state, { payload }: PayloadAction<SetMoveFlowStatePayload>) => {
      state.move[payload.key] = payload.state
    },
    setShowSalesSurvey: (state, { payload }: PayloadAction<Partial<AppStore['salesSurvey']>>) => {
      state.salesSurvey = {
        ...state.salesSurvey,
        ...payload
      }
    },
    resetMoveFlow: (state) => {
      state.move = initialAppState.move
    },
    resetUrlSearchParams: (state) => {
      state.urlSearchParams = initialAppState.urlSearchParams
    },
    resetSalesSurvey: (state) => {
      state.salesSurvey = initialAppState.salesSurvey
    }
  },
  selectors: {
    selectStoreLoaded: (state) => state.storeLoaded,
    selectUrlSearchParams: (state) => state.urlSearchParams,
    selectIsEligibleForSalesSurvey: (state) => state.salesSurvey.isEligible && !!state.salesSurvey.contractId,
    selectShowSalesSurvey: (state) => !!state.salesSurvey.show && state.salesSurvey.isEligible
  },
  extraReducers: (builder) => {
    builder.addCase(REMEMBER_REHYDRATED, (state) => {
      state.storeLoaded = true
    })

    // IS PENDING

    // IS FULFILLED
    builder.addCase(switchLanguage.fulfilled, (state, { payload }) => {
      state.language = payload.language.toUpperCase() as Language
    })

    // IS REJECTED
  }
})

export const {
  activateBetaMode,
  deleteRedirect,
  resetMoveFlow,
  resetSalesSurvey,
  resetUrlSearchParams,
  saveRedirect,
  saveUrlSearchParam,
  setMoveFlow,
  setMoveFlowState,
  setShowAllAddresses,
  setShowSalesSurvey,
  toggleShowAllAddresses
} = appSlice.actions

export const { selectStoreLoaded, selectUrlSearchParams, selectShowSalesSurvey, selectIsEligibleForSalesSurvey } = appSlice.selectors

export default appSlice.reducer
